module.exports = __webpack_public_path__ + "static/assets/666029774737d22f5daf80a1dc31c920.png";